import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    padding: (p) => (p.isMobile ? 0 : theme.spacing(1)),
    '& .MuiTableCell-root': {
      fontSize: 14,
      padding: theme.spacing(1, 2),
    },
    '& tbody tr:last-child td': {
      borderBottom: 'none',
    },
  },
  headerCell: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    fontSize: '13px !important',
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  enabledRow: {
    '& td': { color: theme.palette.text.primary },
  },
  disabledRow: {
    '& td': {
      color: theme.palette.text.disabled,
      fontStyle: 'italic',
    },
  },
  disabledText: {
    color: theme.palette.text.disabled,
    fontStyle: 'italic',
  },
  safetyNote: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
    fontSize: '13px !important',
    padding: theme.spacing(2),
  },
  table: {
    width: '100%',
    '& table': { width: '100%' },
    '& td': { fontSize: 12 },
    '& tr': { cursor: 'pointer' },
  },
  editorContent: {
    padding: theme.spacing(3, 4),
    maxWidth: 800,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 1.5),
      maxWidth: '100%',
      overflowX: 'hidden',
    },
  },
  subtitle: {
    fontSize: '14px !important',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  section: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
    },
  },
  sectionTitle: {
    fontSize: '16px !important',
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  // Fields table
  fieldsHeaderCell: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    fontSize: '13px !important',
    borderBottom: `2px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(0.5),
  },
  fieldsRow: {
    '& td': {
      fontSize: 14,
      padding: theme.spacing(0.5, 1),
    },
  },
  dragHandle: {
    color: theme.palette.text.disabled,
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
  },
  typeLabel: {
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.5px',
    color: theme.palette.text.secondary,
  },
  typeLabelDisabled: {
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.5px',
    color: theme.palette.text.disabled,
  },
  actionIcons: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  addFieldBtn: {
    marginTop: theme.spacing(2),
  },
  requiredNote: {
    fontSize: '12px !important',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    marginTop: theme.spacing(1),
  },
  closeoutRow: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    padding: theme.spacing(1, 2),
  },
  fieldPickerGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
  formStyle: {
    maxWidth: 'none',
    [theme.breakpoints.down('sm')]: {
      '& .MuiFormControl-root': {
        width: '100%',
      },
    },
  },
  configForm: {
    minWidth: 400,
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
      width: '100%',
    },
  },
  floatingButtons: {
    position: 'fixed',
    bottom: theme.spacing(4),
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: theme.spacing(1),
    zIndex: 1300,
    [theme.breakpoints.down('sm')]: {
      bottom: theme.spacing(2),
      width: 'calc(100% - 32px)',
      justifyContent: 'center',
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.grey[700],
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.grey[800],
    },
  },
}));

export default useStyles;
